import React from 'react';
import spinner from './spinner.gif';

export default () => (
  <>
    <img
      src={spinner}
      style={{
        width: '150px', height: '150px', margin: '0 25px', display: 'block',
      }}
      alt="Loading..."
    />
  </>
);
